module.exports = __webpack_public_path__ + "img/01.ea1a82fc.jpg";